import { TERMINE_ARBEITSZEIT_VERKNUEPFUNG_DELETE } from '@/domain/termine/hooks/graphql/mutation';
import {
  DeleteArbeitszeitVerknuepfungMutation,
  DeleteArbeitszeitVerknuepfungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

export function useDeleteArbeitszeitVerknuepfung() {
  const [mutate, { loading }] = useMutation<
    DeleteArbeitszeitVerknuepfungMutation,
    DeleteArbeitszeitVerknuepfungMutationVariables
  >(TERMINE_ARBEITSZEIT_VERKNUEPFUNG_DELETE, {
    refetchQueries: ['GetTagesDaten'],
    awaitRefetchQueries: true,
  });

  const deleteArbeitszeitVerknuepfung = async (
    variables: DeleteArbeitszeitVerknuepfungMutationVariables,
  ) => {
    const result = await mutate({ variables });
    return result.data?.termine_arbeitszeitVerknuepfungDelete;
  };

  return { deleteArbeitszeitVerknuepfung, loading };
}
